<template>
	<div
		class="referenced-symbols"
		v-if="stocks && stocks.length > 0"
	>
		<h2 class="referenced-symbols-title">In this article</h2>
		<ul class="symbols-list">
			<li
				v-for="stock in stocks"
				:key="stock.code"
				class="symbol-item"
				@click="() => selectStock(stock)"
			>
				<span class="symbol-link">{{ stock.SYMBOL }}</span>
				<span
					:class="{
						'symbol-status': true,
						up: stock.PC_CHG > 0,
						down: stock.PC_CHG < 0
					}"
				>
					{{ stock.PC_CHG > 0 ? "+" : "" }}{{ stock.PC_CHG.toFixed(2) }}%

					<template v-if="!stock.PC_CHG === 0">
						<svg
							v-if="breakpoints.isGreater('lg') && stock.PC_CHG > 0"
							height="24px"
							viewBox="0 0 24 24"
							width="24px"
							fill="#4caf50"
						>
							<path
								d="M0 0h24v24H0z"
								fill="none"
							/>
							<path d="M7 14l5-5 5 5z" />
						</svg>
						<svg
							v-else-if="breakpoints.isGreater('lg')"
							xmlns="http://www.w3.org/2000/svg"
							height="24px"
							viewBox="0 0 24 24"
							width="24px"
							fill="#f44336"
						>
							<path
								d="M0 0h24v24H0z"
								fill="none"
							/>
							<path d="M7 10l5 5 5-5z" />
						</svg>
					</template>
				</span>

				<ReferencedStocksOverlay
					v-if="breakpoints.isGreater('lg')"
					:market="stock.MARKET"
					:symbol="stock.SYMBOL"
					:name="stock.NAME"
					:lastPrice="stock.LAST"
					:netChange="stock.NET_CHG"
					:percentChange="stock.PC_CHG"
					:day_low="stock.LOW"
					:day_high="stock.HIGH"
					:volume="stock.VOLUME"
					:float="stock.FLOAT"
				/>
			</li>
		</ul>

		<ReferencedStocksOverlay
			v-if="breakpoints.isSmallerOrEqual('lg') && selectedStock"
			class="active"
			:market="selectedStock.MARKET"
			:symbol="selectedStock.SYMBOL"
			:name="selectedStock.NAME"
			:lastPrice="selectedStock.LAST"
			:netChange="selectedStock.NET_CHG"
			:percentChange="selectedStock.PC_CHG"
			:day_low="selectedStock.LOW"
			:day_high="selectedStock.HIGH"
			:volume="selectedStock.VOLUME"
			:float="selectedStock.FLOAT"
			@close="() => (selectedStock = null)"
		/>
	</div>
	<div v-else />
</template>

<script setup>
import axios from "axios";
import dayjs from "dayjs";
import MD5 from "crypto-js/md5";

dayjs.locale("en");
dayjs.tz.setDefault("America/New_York");

const { symbols } = defineProps(["symbols"]);
const stocks = ref([]);
const breakpoints = reactive(
	useBreakpoints({
		lg
	})
);

const selectedStock = ref(null);

const lg = 1024;
const selectStock = (stock) => {
	if (breakpoints.isSmallerOrEqual("lg")) {
		selectedStock.value = stock;
	}
	return;
};

onMounted(async () => {
	const date = dayjs(Date.now()).format("ddd, D MMM YYYY");

	const secretToken = MD5(date).toString();

	const headers = {
		secretToken: secretToken
	};

	const getStocksInfo = symbols.map(async (symbol) => {
		const data = {
			filter: `SYMBOL IN ('${symbol}')`,
			prevDay: false,
			fields:
				"VOLUME, TRADES, FLOAT, SHORT_INTEREST,SHORT_INTEREST_RATIO, SYMBOL, NAME, LAST, NET_CHG, PC_CHG, MARKET_CAP, HIGH_52W, LOW_52W, LOW, HIGH, DAY_RANGE, MARKET"
		};

		return await axios.post(
			"https://app02.stockstotrade.com:8094/v1.1/symbols",
			data,
			{
				headers
			}
		);
	});

	Promise.all(getStocksInfo).then((res) => {
		res.forEach((r) => {
			if (r.data[0]) stocks.value.push(r.data[0]);
		});
	});
});
</script>

<style lang="scss">
.symbol-item {
	position: relative;
	font-size: 14px;
	margin-right: 4px;
	list-style: none;

	@include breakpoint(lg) {
		font-size: 16px;
		margin-right: 0;
	}

	svg {
		height: 20px;
		@include breakpoint(lg) {
			height: 24px;
		}
	}
}
.referenced-symbols {
	background-color: #f4f4f4;
	padding: 12px;
	border-radius: 12px;
	margin-bottom: 24px;
	@include breakpoint(lg) {
		padding: 20px;
	}
}

.referenced-symbols-title {
	color: $slate-900;
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 4px;
	@include breakpoint(lg) {
		font-size: 20px;
	}
}

.symbols-list {
	list-style-type: none;
	padding: 0;
}

.symbol-link {
	color: $slate-900;
	margin-right: 4px;
	text-decoration: none;
}

.symbol-status {
	margin-left: 0px;
	font-weight: bold;
	display: inline-flex;
	color: $slate-500;
}

.symbol-status.up {
	color: #4caf50;
}

.symbol-status.down {
	color: #f44336;
}

.symbols-list {
	display: flex;
	flex-wrap: wrap;
	column-gap: 8px;
	row-gap: 4px;
	@include breakpoint(lg) {
		column-gap: 12px;
		row-gap: 8px;
	}
}
</style>
